import React from "react";
import { isArray } from "lodash";
import * as qs from "query-string";

import IFrame from "./IFrame";
import Loader from "../ui/Loader";
import GetItem from "../../helpers/dataProviders/getItem";

class FormViewer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hasIFrameMounted: false,
			formUrl: null,
		};
	}

	async componentDidMount() {
		const query = qs.parse(this.props.location.search);
		let { url: formUrl } = query;

		if (!formUrl) this.redirectHome();

		// testing URLs
		// formUrl = "https://verrisapp.formstack.com/forms/dev_form";
		// formUrl = "https://verrisapp.formstack.com/forms/dev_form_2?no_style_strict=1";
		// formUrl = "https://verrisapp.formstack.com/forms/dev_form_3__advanced";

		this.setState({ formUrl });
	}

	shouldComponentUpdate(_, nextState) {
		const { formUrl: nextFormUrl } = nextState;
		const { formUrl: thisFormUrl, hasIFrameMounted: thisHasIFrameMounted } = this.state;

		if (thisHasIFrameMounted) {
			console.log("sCU -> thisHasIFrameMounted == true");
			if (nextFormUrl !== thisFormUrl) {
				console.log("sCU -> formUrl changed, update");
				return true;
			} else {
				console.log("sCU -> formUrl did not change, do not update");
				return false;
			}
		} else {
			console.log("sCU -> thisHasIFrameMounted == false, update");
			return true;
		}
	}

	redirectHome = () => {
		let redirectLocation =
			process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://app.verrisapp.com/";
		window.location.href = redirectLocation;
	};

	render() {
		const { formUrl } = this.state;

		return formUrl ? (
			<IFrame src={formUrl} id="form-viewer" onMount={() => this.setState({ hasIFrameMounted: true })} />
		) : (
			<div style={{ width: "100vw", height: "100vh" }}>
				<Loader />
			</div>
		);
	}
}

export default FormViewer;
